import { Component, input } from '@angular/core';

import { SelectControlComponent } from '../select-control/select-control.component';
import { autoComplete_value, IAutoComplete } from '../../models/auto-complete.model';
import { fieldAppearance, TFieldAppearance } from '../../models/form-field-options';
import { _ValueControlComponent } from '../../components/_value-control.component';

// Select zonder FormControl: [value]/(valueChange) met de itemId (of string) als waarde. De
// onderliggende app-select-control werkt met het hele lijst-item; die vertaling gebeurt hier.
@Component({
    selector: 'app-select',
    templateUrl: './select.component.html',
    standalone: true,
    imports: [
        SelectControlComponent,
    ],
})
export class SelectComponent
    extends _ValueControlComponent<string | number>
{
    input_appearance$$  = input<TFieldAppearance>(fieldAppearance.fill, { alias: 'appearance' });
    input_list$$        = input<IAutoComplete[] | string[]>([],         { alias: 'list' });
    input_placeholder$$ = input<string>('',                            { alias: 'placeholder' });

    override out_valueChange = this._out_valueChange;

    override control$$  = this._control$$;
    override disabled$$ = this._input_disabled$$;
    override label$$    = this._input_label$$;
    override readonly$$ = this._input_readonly$$;
    override value$$    = this._input_value$$;

    emit_valueChange(item: IAutoComplete | string): void {
        super._emit_valueChange(autoComplete_value(item));
    }

    protected override _controlValue(value: string | number | null): unknown {
        if (value === null) return null;

        const _list = this.input_list$$() as (IAutoComplete | string)[];
        return _list.find(item => autoComplete_value(item) === value) ?? null;
    }
}
